import { uniq, xor } from 'lodash/fp';
import { makeAutoObservable } from 'mobx';
import moment from 'moment';

export class PredictionsFeedStore {
    public maxDate: moment.Moment;
    public minDate: moment.Moment;
    public selectedCountries: number[] = [];
    public searchString: string = '';
    public currentIds: string[] = [];

    constructor() {
        makeAutoObservable(this);
    }

    public toInitialState() {
        this.maxDate = null;
        this.minDate = null;
        this.selectedCountries = [];
        this.searchString = '';
        this.currentIds = [];
    }

    public toggleCountry(countryId: number) {
        this.selectedCountries = xor([countryId], this.selectedCountries);
    }

    public addCountry(countryId: number) {
        this.selectedCountries = uniq([...this.selectedCountries, countryId]);
    }

    public removeCountry(countryId: number) {
        this.selectedCountries = this.selectedCountries.filter(
            id => id !== countryId
        );
    }

    public setSelectedCountries(countryIds: number[]) {
        this.selectedCountries = [...countryIds];
    }

    public resetDateFilter() {
        this.minDate = null;
        this.maxDate = null;
    }
}

export default new PredictionsFeedStore();
